"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));
var _pick = _interopRequireDefault(require("lodash/pick"));
var _i18n = require("../../i18n");
var _LoadingContentSwitch = _interopRequireDefault(require("../LoadingContentSwitch"));
var _helpers = require("./helpers");
var _isLoading = _interopRequireDefault(require("./isLoading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OptionalComponents = _ref => {
  let {
    fields,
    onChange,
    onCustomizeComponents,
    customSubtext,
    style,
    resetFields
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  const flatFields = getFlatFields(fields);
  const [components, setComponents] = (0, _react.useState)(() => getInitialComponents(flatFields));
  (0, _react.useEffect)(() => {
    setComponents(getInitialComponents(flatFields));
  }, [resetFields, JSON.stringify(flatFields)]);
  (0, _react.useEffect)(() => {
    onChange(components);
  }, [JSON.stringify(components)]);
  const handleOnChange = field => value => {
    setComponents(state => {
      const newComponents = {
        ...getMergedComponents(state, flatFields),
        [field]: value
      };
      const updatedState = getCustomizedComponents(newComponents);
      onChange(updatedState);
      return updatedState;
    });
  };
  const getCustomizedComponents = components => {
    return (0, _helpers.validateOptionalComponents)(components) ? onCustomizeComponents(components) : components;
  };
  const fieldsHaveGroups = flatFields.some(field => Boolean(field.group));
  const renderComponents = fieldsHaveGroups ? renderComponentsWithGroups : renderComponentsWithoutGroups;
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_LoadingContentSwitch.default, {
      showContent: false
    })
  }, /*#__PURE__*/_react.default.createElement(_LoadingContentSwitch.default, {
    showContent: (0, _isLoading.default)(fields)
  }, customSubtext !== '' && /*#__PURE__*/_react.default.createElement(Subtitle, {
    instructions: true
  }, customSubtext || T.translate('optionalComponents.instructions')), renderComponents({
    flatFields,
    handleOnChange,
    components,
    style
  })));
};
const renderComponentsWithGroups = _ref2 => {
  let {
    flatFields,
    handleOnChange,
    components,
    style
  } = _ref2;
  const groups = getGroups(flatFields);
  return Object.keys(groups).map(group => /*#__PURE__*/_react.default.createElement("div", {
    key: group
  }, /*#__PURE__*/_react.default.createElement(Subtitle, null, group), groups[group].map(component => (0, _helpers.getComponentByType)({
    component,
    handleOnChange,
    components,
    style
  }))));
};
const renderComponentsWithoutGroups = _ref3 => {
  let {
    flatFields,
    handleOnChange,
    components,
    style
  } = _ref3;
  return flatFields.map(component => (0, _helpers.getComponentByType)({
    component,
    handleOnChange,
    components,
    style
  }));
};
const getGroups = fields => (0, _groupBy.default)(assignGeneralGroup(fields), 'group');
const assignGeneralGroup = fields => fields.map(field => field.group ? field : {
  ...field,
  group: 'General'
});
const getMergedComponents = (components, fields) => {
  const initialComponents = getInitialComponents(fields);
  const customizer = (objValue, srcValue) => (0, _pick.default)(srcValue, ...Object.keys(objValue));
  return (0, _mergeWith.default)(initialComponents, components, customizer);
};
const getFlatFields = fields => fields.flatMap(field => [field, ...(field.children || []).map(child => ({
  ...child,
  parent: field.field
}))]);
const getInitialComponents = flatFields => {
  return (0, _reduce.default)(flatFields, (result, _ref4) => {
    let {
      field,
      default: defaultValue,
      type,
      options,
      value,
      readOnly,
      parent
    } = _ref4;
    if (type === 'dropdown') {
      const selectedOption = options.find(_ref5 => {
        let {
          default: selected
        } = _ref5;
        return Boolean(selected);
      });
      result[field] = {
        enabled: true,
        value: selectedOption.value
      };
    } else {
      result[field] = {
        enabled: defaultValue,
        value,
        readOnly,
        parent
      };
    }
    return result;
  }, {});
};
const Subtitle = _styledComponents.default.div`
  ${{
  ..._alloyReactTheme.default.typography.labelSmall
}}
  color: #666666;
  font-size: 12px;
  margin-top: ${_ref6 => {
  let {
    instructions
  } = _ref6;
  return instructions ? '-0.7em' : '1em';
}};
`;
OptionalComponents.defaultValues = {
  onChange: () => {},
  fields: [],
  value: {},
  customSubtext: '',
  onCustomizeComponents: components => components
};
OptionalComponents.propTypes = {
  fields: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func,
  onCustomizeComponents: _propTypes.default.func,
  customSubtext: _propTypes.default.string,
  style: _propTypes.default.object,
  resetFields: _propTypes.default.bool.isRequired
};
var _default = exports.default = OptionalComponents;